import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import GeneralEmbeddedApp from 'lumen/components/general/embedded-app';
import type HotelSnapshotSpiderDashboardController from 'lumen/controllers/hotel/snapshot/spider-dashboard';
import contextualPageTitle from 'lumen/helpers/contextual-page-title';
import getEnv from 'lumen/helpers/get-env';

interface HotelSnapshotSpiderDashboardSignature {
  Args: {
    controller: HotelSnapshotSpiderDashboardController;
    model: unknown;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "menu.spider.snapshot"))}}

  <GeneralEmbeddedApp
    {{! @glint-expect-error: Incorrect type }}
    @baseURL={{getEnv "spiderIframeURL"}}
    @id="spider-hotel-snapshot"
    @query={{@controller.iframeQPs}}
    @url={{@controller.urlForEmbeddedApp}}
  />
</template> satisfies TOC<HotelSnapshotSpiderDashboardSignature>;
